import React from 'react';
import { Grid } from '@material-ui/core';
import { Check } from 'react-feather';
import { DisplayItem } from '../../../types';
import colors from '../../../theme/colors';

/**
 * Returns an option row that can be used for different dropdown implementations.
 * Note: you need to wrap the result in a MenuItem before using it inside a Select
 *
 * @param option - The option to be rendered
 * @param selected - Whether this is the selected option
 * @param className - Optional custom className
 */
export default function renderOption(
  option: DisplayItem,
  selected: boolean,
  className = '',
): React.ReactNode {
  return (
    <Grid container alignItems="center" className={className}>
      <Grid item xs={11}>
        {option.Text}
      </Grid>
      <Grid item xs={1} container justifyContent="flex-end">
        {selected && <Check size={15} color={colors.shamrock} />}
      </Grid>
    </Grid>
  );
}
